import React from 'react';
import {
  Button,
  Divider,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import SalonThemeCompactFontPicker from './SalonThemeCompactFontPicker';
import SalonThemeEssentialColorControls from './SalonThemeEssentialColorControls';
import SalonThemeFeaturedTemplates from './SalonThemeFeaturedTemplates.jsx';


const SalonThemeEssentialControls = ({
  appearance,
  errors,
  disabled,
  onTemplateChange,
  onThemeFieldChange,
  onThemeFieldBlur,
  onOpenAdvanced,
  registerFieldRef,
}) => {
  const { t } = useTranslation();

  return (
    <Paper
      data-testid="salon-theme-essential-controls"
      style={{ padding: '16px' }}
    >
      <Stack
        data-testid="salon-theme-essential-stack"
        style={{ gap: '12px' }}
      >
        <SalonThemeFeaturedTemplates
          value={appearance.template_key}
          disabled={disabled}
          onChange={onTemplateChange}
          focusRef={(element) => registerFieldRef('template_key', element)}
        />
        <Stack spacing={1.25}>
          <Typography component="h3" variant="subtitle1" fontWeight={700}>
            {t('salon_theme.essential.colors')}
          </Typography>
          <SalonThemeEssentialColorControls
            draft={appearance.theme}
            errors={errors.theme}
            disabled={disabled}
            onFieldChange={onThemeFieldChange}
            onFieldBlur={onThemeFieldBlur}
            registerFieldRef={registerFieldRef}
          />
        </Stack>
        <SalonThemeCompactFontPicker
          value={appearance.theme.font_key}
          error={errors.theme.font_key}
          disabled={disabled}
          accentColor={appearance.theme.primary_color}
          onChange={(fontKey) => onThemeFieldChange('font_key', fontKey)}
          focusRef={(element) => registerFieldRef('font_key', element)}
        />
        <Divider />
        <Button
          disabled={disabled}
          onClick={onOpenAdvanced}
          sx={{ minHeight: 44 }}
        >
          {t('salon_theme.essential.advanced')}
        </Button>
      </Stack>
    </Paper>
  );
};

export default SalonThemeEssentialControls;
